var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalyticsBiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4.54545,
    fill: "#EFF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 12.8125C14.2678 12.8125 14.6875 13.2322 14.6875 13.75V35.3125H36.25C36.7678 35.3125 37.1875 35.7322 37.1875 36.25C37.1875 36.7678 36.7678 37.1875 36.25 37.1875H13.75C13.2322 37.1875 12.8125 36.7678 12.8125 36.25V13.75C12.8125 13.2322 13.2322 12.8125 13.75 12.8125Z",
    fill: "url(#paint0_linear_981_3917)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 31.25L23.75 21.25L30 26.875L36.25 13.75V31.25H18.75Z",
    fill: "url(#paint1_linear_981_3917)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4566 12.8356C36.884 12.9321 37.1875 13.3118 37.1875 13.75V31.25C37.1875 31.7678 36.7678 32.1875 36.25 32.1875H18.75C18.4251 32.1875 18.1233 32.0193 17.9525 31.7429C17.7817 31.4665 17.7662 31.1214 17.9115 30.8307L22.9115 20.8307C23.0424 20.569 23.288 20.3833 23.5756 20.3289C23.8631 20.2744 24.1596 20.3574 24.3772 20.5532L29.6936 25.3379L35.4036 13.3469C35.5919 12.9513 36.0292 12.739 36.4566 12.8356ZM35.3125 17.8993L30.8464 27.2781C30.7192 27.5452 30.4734 27.7366 30.1833 27.7944C29.8932 27.8523 29.5927 27.7697 29.3728 27.5718L24.0379 22.7704L20.2669 30.3125H35.3125V17.8993Z",
    fill: "url(#paint2_linear_981_3917)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_981_3917",
    x1: 25,
    y1: 12.8125,
    x2: 25,
    y2: 37.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1155BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_981_3917",
    x1: 27.5,
    y1: 13.75,
    x2: 27.5,
    y2: 31.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1155BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_981_3917",
    x1: 27.5,
    y1: 12.8124,
    x2: 27.5,
    y2: 32.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1155BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB2EE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsBiIcon);
export default __webpack_public_path__ + "static/media/analytics-bi-icon.2ab16f409ac36ee2510a7af92aadce9e.svg";
export { ForwardRef as ReactComponent };